import React, {Component} from 'react';
import Styles from './style.css';
import cx from 'classnames';
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class BoosterHomeCompareYL extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
    };

    componentWillMount() {
        this._updateItems();
    }

    _updateItems() {
        let items = [
            {
                title: this._renderText("item_3"),
                classic: {exist: true, value: "–"},
                yieldlock: {exist: true, value: "–"},
                offplan: {exist: true, value: "checkmark"}
            },
            {
                title: this._renderText("item_4"),
                classic: {exist: true, value: "–"},
                yieldlock: {exist: true, value: "–"},
                offplan: {exist: true, value: "–"}
            },
            {
                title: this._renderText("item_5"),
                classic: {exist: true, value: "–"},
                yieldlock: {exist: true, value: "–"},
                offplan: {exist: true, value: "–"}
            },
            {
                title: this._renderText("item_6"),
                classic: {exist: true, value: "–"},
                yieldlock: {exist: true, value: "–"},
                offplan: {exist: true, value: "–"}
            },
            {
                title: this._renderText("item_7"),
                classic: {exist: true, value: "–"},
                yieldlock: {exist: true, value: "–"},
                offplan: {exist: true, value: "–"}
            },
            {
                title: this._renderText("item_8"),
                classic: {exist: true, value: "–"},
                yieldlock: {exist: true, value: "–"},
                offplan: {exist: true, value: "–"}
            },
            {
                title: this._renderText("item_9"),
                classic: {exist: true, value: "–"},
                yieldlock: {exist: true, value: "–"},
                offplan: {exist: true, value: "–"}
            },
            {
                title: this._renderText("item_10"),
                classic: {exist: true, value: "–"},
                yieldlock: {exist: true, value: "–"},
                offplan: {exist: true, value: "–"}
            },
            {
                title: this._renderText("item_11"),
                classic: {exist: true, value: "–"},
                yieldlock: {exist: true, value: "low"},
                offplan: {exist: true, value: "medium"}
            },
            {
                title: this._renderText("item_12"),
                classic: {exist: true, value: 'medium'},
                yieldlock: {exist: true, value: "low"},
                offplan: {exist: true, value: "high"}
            }
        ];
        this.setState({items: items});
    }

    boost(){
        window.scrollTo(0, 0);
    }

    _renderText(item) {
        return langRegister.get("home-sections-eight", item);
    }

    render() {
        return (
            <div className={Styles.section}>
                <div className={Styles.container}>
                    <div className={Styles.table}>
                        <div className={cx(Styles.tableItem)}>
                            <div className={cx(Styles.tableSectionOne)}/>
                            <div className={cx(Styles.tableSectionTwo, Styles.tableItemTop)}>
                                <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableTitle}>
                                    {this._renderText("item_24")}
                                </div>
                            </div>
                            <div className={cx(Styles.tableSectionTwo, Styles.tableItemTop)}>
                                <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableTitle}>
                                    {this._renderText("item_25")}
                                </div>
                            </div>
                            <div className={cx(Styles.tableSectionThree, Styles.tableItemTop)}>
                                <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableTitle}>
                                    {this._renderText("item_26")}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.items.map((item, key) => {
                                return (
                                    <div className={Styles.tableItem}>
                                        <div className={
                                            cx(Styles.tableSectionOne,
                                                {
                                                    [Styles.tableSectionOneOther]: salesChannelRegister.get("name") !== "yieldlock"
                                                })
                                        }>
                                            <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableSectionOneTitle}>
                                                {item.title}
                                            </div>
                                        </div>
                                        <div className={
                                            cx(Styles.tableSectionThree,
                                                {
                                                    [Styles.tableSectionThreeActive]: item.classic.exist,
                                                })
                                        }>
                                            {
                                                item.classic.value === '–' &&
                                                <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableSectionTitleSecondGray}>
                                                    {item.classic.value}
                                                </div>
                                            }
                                            {
                                                item.classic.value !== '–' &&
                                                <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableSectionTitleSecondDarkBlue}>
                                                    {item.classic.value}
                                                </div>
                                            }
                                        </div>
                                        <div className={
                                            cx(Styles.tableSectionTwo,
                                                {
                                                    [Styles.tableSectionTwoActive]: item.yieldlock.exist,
                                                    [Styles.tableSectionTwoActiveFirst]: key === 0,
                                                    [Styles.tableSectionTwoActiveLast]: key === this.state.items.length - 1,
                                                })
                                        }>
                                            <div className={Styles.tableSectionTitle}>
                                                {
                                                    item.yieldlock.value === '–' &&
                                                    <img className={Styles.tableSectionTitleIcon} src={require("../../assets/images/AB_checkmark_YL.png")}/>
                                                }
                                                {
                                                    item.yieldlock.value !== '–' &&
                                                    <span className={Styles.tableSectionTitleSecond}>{item.yieldlock.value}</span>
                                                }
                                            </div>
                                        </div>
                                        <div className={
                                            cx(Styles.tableSectionThree,
                                                {
                                                    [Styles.tableSectionThreeActive]: item.offplan.exist,
                                                })
                                        }>
                                            {
                                                item.offplan.value === '–' &&
                                                <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableSectionTitleSecondGray}>
                                                    {item.offplan.value}
                                                </div>
                                            }
                                            {
                                                item.offplan.value !== '–' && item.offplan.value !== 'checkmark' &&
                                                <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#00273A'}:{}} className={Styles.tableSectionTitleSecondDarkBlue}>
                                                    {item.offplan.value}
                                                </div>
                                            }
                                            {
                                                item.offplan.value === 'checkmark' &&
                                                <img className={Styles.tableSectionTitleIcon} src={require("../../assets/images/AB_checkmark_YL_darkblue.png")}/>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div onClick={() => this.boost()} className={Styles.button}>
                        {this._renderText("item_19")}
                    </div>
                </div>
            </div>
        );
    }
}

export default BoosterHomeCompareYL;


// WEBPACK FOOTER //
// ./src/components/booster-home-compare-yl/component.js